// @flow
import styled from "styled-components";
import {topHeaderBarHeight} from "../../../../TopBar/TopBarStyle";

export const floatingMarkerWidth = 41;
export const floatingMarkerHeight = 49;

export const FreeSelectionFloatingPinContainer = styled.div`
    position: absolute;
    height: 100%;
    width: 100%;
    pointer-events: none;
    
    > img {
        height: ${floatingMarkerHeight}px;
        width: ${floatingMarkerWidth}px;
        position: fixed;
        top: calc((50% + ${topHeaderBarHeight}) - (${floatingMarkerHeight * 1.5}px));
        left: calc(50% - (${floatingMarkerWidth / 2}px));
        right: calc(50% - (${floatingMarkerWidth / 2}px));
        z-index: 1;
    }
`;


// WEBPACK FOOTER //
// ./src/Components/Screen/RideRequest/FreeSelection/FreeSelectionFloatingPin/FreeSelectionFloatingPinStyle.js